import cls from "./PostCard.module.scss"
import { UserInitials } from "./UserInitials/UserInitials"
import bridge from "@vkontakte/vk-bridge"
import { Div, Input, Panel, PanelHeader, PanelHeaderBack } from "@vkontakte/vkui"
import { useUnit } from "effector-react"
import { ChangeEvent, memo, useCallback, useEffect, useRef, useState } from "react"
import { AppPanelsT } from "src/app/providers/RouteProvider/lib/routeConfig"
import { $prevActivePanel, setActivePanel } from "src/entity/ActivePanel"
import { $isStandAlone } from "src/entity/User"
import { $isImageCropped, CropImage } from "src/features/cropImage"
import { SavePostCard } from "src/features/savePostCard"
import { UploadImage } from "src/features/uploadImage"
import krs from "src/shared/assets/images/carusel-logo.svg"
import cloud_1 from "src/shared/assets/images/cloud_1.svg"
import cloud_2 from "src/shared/assets/images/cloud_2.svg"
import cloud_3 from "src/shared/assets/images/cloud_3.svg"
import crown from "src/shared/assets/images/crown.svg"
import mh_logo from "src/shared/assets/images/main_heroes_logo.svg"
import { Cover } from "src/shared/ui/cover"
import { Title, TitleSize } from "src/shared/ui/title/Title"

interface IPostCardPanelProps {
  id: AppPanelsT
}

export const PostCardPanel = memo(({ id }: IPostCardPanelProps) => {
  const [isImageCropped, onSetActivePanel, prevActivePanel, isStandAlone] = useUnit([$isImageCropped, setActivePanel, $prevActivePanel, $isStandAlone])

  const [isShowNameInput, setIsShowNameInput] = useState<boolean>(false)
  const [isShowLastnameInput, setIsShowLastnameInput] = useState<boolean>(false)
  const [isShowName, setIsShowName] = useState<boolean>(true)
  const [isShowLastname, setIsShowLastname] = useState<boolean>(true)
  const [name, setName] = useState<string>("Имя")
  const [lastname, setLastname] = useState<string>("Фамилия")

  const onNameClick = useCallback(() => {
    // @ts-ignore
    bridge.send("VKWebAppSendCustomEvent", {
      event: "accreditation_name_click",
    })

    setIsShowName(false)
    setName("")
    setIsShowNameInput(true)
  }, [])

  const onNameInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setName(e.currentTarget.value)
  }, [])

  const onNameInputBlur = useCallback(() => {
    if (!name.length) {
      setName("Имя")
    }
    setIsShowName(true)
    setIsShowNameInput(false)
  }, [name])

  const onLastnameClick = useCallback(() => {
    // @ts-ignore
    bridge.send("VKWebAppSendCustomEvent", {
      event: "accreditation_surname_click",
    })

    setIsShowLastname(false)
    setLastname("")
    setIsShowLastnameInput(true)
  }, [])

  const onLastnameInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLastname(e.currentTarget.value)
  }, [])

  const onBackClick = useCallback(() => {
    if (!prevActivePanel) return

    onSetActivePanel(prevActivePanel)
  }, [onSetActivePanel, prevActivePanel])

  const onLastnameInputBlur = useCallback(() => {
    if (!lastname.length) {
      setLastname("Фамилия")
    }
    setIsShowLastname(true)
    setIsShowLastnameInput(false)
  }, [lastname])

  const postCardPanelRef = useRef<HTMLDivElement>(null)
  const [savingElement, setSavingElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const blockHeight = document.querySelector(".postcard-content-wrapper")?.clientHeight
    setSavingElement(postCardPanelRef.current)
    window.parent.postMessage({ type: "iframeResize", height: (blockHeight || 830) + 40 }, "*")
  }, [])

  return (
    <div id={id} className={`postcard_block ${cls.panelWrapper}`}>
      <div className={cls.panelWrapperBackground}>
        <img className={cls.panelWrapperBackgroundImage_1} src={cloud_2} alt="cloud_carusel" />
        <img className={cls.panelWrapperBackgroundImage_2} src={cloud_3} alt="cloud_carusel" />
      </div>
      <div className={cls.panelWrapperFrontground}>
        <img className={cls.panelWrapperFrontgroundImage_1} src={cloud_1} alt="cloud_carusel" />
      </div>
      <PanelHeader transparent visor={false} separator={false} style={{ width: "0px" }} />
      <div className="postcard-content-wrapper" ref={postCardPanelRef}>
        <Div className={cls.postCardWrapper}>
          <Div className={cls.header}>
            <PanelHeaderBack onClick={onBackClick} />
            <img className={cls.img} src={krs} alt="krs" />
          </Div>

          <Div className={cls.content}>
            <img className={cls.imageStaticMH} src={mh_logo} alt="" />
            <img className={cls.imageStaticCrown} src={crown} alt="" />
            <Div>
              <Title align="center" className={cls.title} size={TitleSize.L}>
                Жюри
              </Title>
            </Div>

            <Div className={cls.photo}>
              <UploadImage />
              <CropImage />
            </Div>

            <Div className={cls.signature}>
              {isShowName && <UserInitials onClick={onNameClick} text={name} />}
              {isShowNameInput && <Input className={cls.inputText} autoFocus onBlur={onNameInputBlur} onChange={onNameInputChange} value={name} />}
              {isShowLastname && <UserInitials onClick={onLastnameClick} text={lastname} />}
              {isShowLastnameInput && <Input className={cls.inputText} autoFocus onBlur={onLastnameInputBlur} onChange={onLastnameInputChange} value={lastname} />}
            </Div>
          </Div>
        </Div>
        <Cover />
      </div>

      {isImageCropped && <SavePostCard savingElement={savingElement} />}
      {/* Раскоментить как починю */}
      {/* {(isImageCropped && !isStandAlone) && <SharePostCardToVk savingElement={savingElement} />} */}
    </div>
  )
})
